import { FC } from 'react';
import type { TableBlock as TableBlockType } from '@/types/blocks';
import { ExpandDrawer } from './ExpandDrawer';
import { formatCompactNumber } from '@/utils/formatCompactNumber';

interface TableDrawerProps {
  block: TableBlockType;
  open: boolean;
  onClose: () => void;
}

export const TableDrawer: FC<TableDrawerProps> = ({ block, open, onClose }) => {
  return (
    <ExpandDrawer open={open} onClose={onClose} title={block.title ?? 'Table'}>
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-peach dark:bg-grey-sky-dark">
            {block.columns.map((col, i) => (
              <th
                key={i}
                className="whitespace-nowrap border-b border-peach-1 px-4 py-3 text-left font-medium text-grey-black dark:border-grey-plain-dark dark:text-grey-main-dark"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {block.rows.map((row, ri) => (
            <tr
              key={ri}
              className="border-t border-peach-1 transition-colors even:bg-grey-light hover:bg-peach/60 dark:border-grey-plain-dark dark:even:bg-grey-sky-dark dark:hover:bg-grey-dark"
            >
              {row.map((cell, ci) => (
                <td key={ci} className="whitespace-nowrap px-4 py-3 text-grey-main dark:text-grey-medium-dark">
                  {formatCompactNumber(cell)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </ExpandDrawer>
  );
};
